import {
  CiselnikPolozka,
  SprievodnyDokumentListExternalApi,
  StadiumMaterialuEnum,
} from 'ciselniky-frontend-ts-axios';
import PolozkaCiselnik from '../../../model/ciselniky/PolozkaCiselnik';
import { ClientResponse } from '../../../model/ClientResponse';
import apiConfiguration from '../../configuration/apiConfiguration';
import { ciselnikyPrefixPath } from '../../configuration/apiConfigurationConstants';
import Uuid from '../../../model/Uuid';

const client = new SprievodnyDokumentListExternalApi(apiConfiguration(ciselnikyPrefixPath));

function map(polozky: CiselnikPolozka[]): PolozkaCiselnik[] {
  return polozky.map(it => ({
    uuid: it.uuid,
    nazov: it.nazov,
    platny: it.platny,
  }));
}

// eslint-disable-next-line import/prefer-default-export
export const fetchSprievodnyDokumentTypList = async (
  platny: boolean,
  generovany: boolean,
  povinny: boolean,
  stadium: StadiumMaterialuEnum,
  typMaterialuUuid: Uuid,
  headers?: object,
): Promise<ClientResponse<PolozkaCiselnik[]>> => {
  const {
    data,
    status,
  } = await client.getSprievodnyDokumentList(platny, povinny, generovany, stadium, typMaterialuUuid, headers);
  return {
    data: map(data),
    responseCode: status,
  };
};
